module.exports = __webpack_public_path__ + "img/4.6769a078.jpg";